export const fillInputValue = (inputId: string | undefined, value: string) => {
  if (inputId && document.querySelector(inputId)) {
    (document.querySelector(inputId) as HTMLInputElement).value = value;
  }
};
